import { render, staticRenderFns } from "./decorateGarbageClear.vue?vue&type=template&id=09979b24&scoped=true&"
import script from "./decorateGarbageClear.vue?vue&type=script&lang=js&"
export * from "./decorateGarbageClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09979b24",
  null
  
)

export default component.exports